module.exports = __webpack_public_path__ + "./docs/img/icon-setter.7456b635c0b74df13f4f0e08e9be49ca.svg";